import type { GridOptions } from "ag-grid-enterprise";

export const NO_CLIENT_EXPORT: Pick<
  GridOptions,
  "suppressCsvExport" | "suppressExcelExport"
> = {
  suppressCsvExport: true,
  suppressExcelExport: true,
};
